<template>
  <div>
    <span class="sf-block sf-below-1">{{ title }}</span>
    <select
      class="sf-form-select sf-inline sf-full-width sf-below-2"
      :class="selectClass"
      :name="name"
      @change="handleChange"
    >
      <option
        disabled
        :selected="modelValue === 'placeholder'"
        value="placeholder"
      >
        {{ placeholderLabel }}
      </option>
      <option
        v-for="item in options"
        :key="item.value"
        :value="item.value"
        :selected="item.selected"
      >
        {{ item.label }}
      </option>
    </select>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

defineOptions({
  name: 'AdjustmentsSelect',
})

interface Props {
  isDisabled: boolean
  modelValue: string | number
  name: string
  options: Array<{
    label: string
    value: string | number
    selected: boolean
  }>
  placeholderLabel: string
  title: string
}

const props = withDefaults(defineProps<Props>(), {
  isDisabled: false,
  modelValue: 'placeholder',
  name: '',
  options: () => [],
  placeholderLabel: 'Select',
  title: '',
})

const emit =
  defineEmits<{
    change: [value: string | null]
    'update:modelValue': [value: string | null]
  }>()

const selectClass = computed(() => (props.isDisabled ? 'sf-disabled' : ''))

const handleChange = (event: Event) => {
  const target = event.target as HTMLSelectElement
  emit('update:modelValue', target.value)
}
</script>
